import React from 'react';
import { usePager } from '../../../helpers/pagination';
import SideBar from '../../Common/SideBar';
import PageIndicator from '../../Common/PageIndicator';
import Row from './Row';
import SpotlightHeader from '../../Common/Header';
import './ACRByStoreLeaderboard.scss';
const getFormattedData = (data, metadata) => {
  var _metadata$results;
  const {
    top,
    own
  } = data;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const description = 'Yesterday\'s ACR leaders';
  const values = top === null || top === void 0 ? void 0 : top.slice(0, results);
  const isOwnInRanking = (own === null || own === void 0 ? void 0 : own.ranking) <= results;
  const hidePoweredByShift = metadata.hide_poweredbyshift;
  return {
    description,
    values,
    own,
    isOwnInRanking,
    hidePoweredByShift
  };
};
const ACRByStoreLeaderboard = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    description,
    values,
    own,
    isOwnInRanking,
    hidePoweredByShift
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(values, duration * 1000, playing);
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "acr-leaderboard-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: "acr-leaderboard-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: "location_header"
  }, "Location"), /*#__PURE__*/React.createElement("p", null, "ACR")), page.map((e, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${e.name}-${index}`,
    location: e,
    accent_color: accent_color,
    own: own
  })), !!own && !isOwnInRanking && /*#__PURE__*/React.createElement(Row, {
    key: `${own.name}`,
    location: own,
    accent_color: accent_color,
    own: own
  })), pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  }))), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyshift: hidePoweredByShift
  }));
};
export default ACRByStoreLeaderboard;